import { container } from '../../../DataDomain';
import { IChannelInfoResponse, IGetChannelInfoParams } from '../../../entity';
import { IChannelRepository } from '../../repositories/interfaces/iChannelRepository';
import { IApiPathManager } from '../../../infrastructures/config/ApiPathManager';
import { DI } from '@intigral/constant/config/DIContainer';
import { API_IDS } from '@intigral/constant';
import ResponseError from '../../entities/errors/ResponseError';

export interface IGetChannelInfoUseCase {
    execute(params: IGetChannelInfoParams): Promise<IChannelInfoResponse>;
}

export class GetChannelInfoUseCase implements IGetChannelInfoUseCase {
    // Lazy getters for dependencies to avoid circular dependencies
    private get channelsRepo(): IChannelRepository {
        return container.resolve<IChannelRepository>(DI.REPOSITORIES.IChannelRepository);
    }

    private get apiPathManager(): any {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(params: IGetChannelInfoParams): Promise<IChannelInfoResponse> {
        const response = await this.channelsRepo.getChannelInfo(params);
        if (typeof response.data !== 'undefined') {
            return response;
        }
        if (typeof response.error !== 'undefined') {
            const path = this.apiPathManager.getPath(API_IDS.CHANNEL_INFO);
            throw new ResponseError(
                { url: path },
                {
                    code: response.status || 0,
                    message: response.error || 'Unknown error',
                }
            );
        }
        return response;
    }
}
